import {
    apiRequest,
    positionBknCreate,
} from "../../../../../services/adapters/master/positionBknService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", positionBknCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository